module.exports = "<core-nav></core-nav>\r\n<core-notifier></core-notifier>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 16